import { http } from 'services/http';
import type { UpdateUserReq, UserRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { USERS_ALL } from '../query-keys.ts';

export const useUpdateUser = (userId: number) => {
  return useMutationBase<UserRes, unknown, UpdateUserReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<UserRes>(`/v1/users/${userId}`, variables);

      return res.data;
    },

    invalidateCallback: () => [[USERS_ALL]],
  });
};
